import { useAuthorization } from 'components/Authorization';
import { noop } from 'lodash-es';
import { useCallback } from 'react';
import { logoutOffline } from 'services/api/conversation';
import logout from 'utils/logout';
import { LogoutType } from 'utils/nimKick';
import { useOrgConfigStateValue } from './business/useOrgConfig';
import { useGetPermission } from './business/useNewPermisson';
import { advanceQueryConversationList } from 'services/api/conversation.convList';
import { Modal } from 'antd';
import { useTranslate } from '@tolgee/react';

// 退出离线保护
export const useLogoutOfflineProtect = () => {
  const { payload } = useAuthorization<Oversea.Token.Payload>();

  return async (protect = false) => {
    if (!protect && payload) {
      const { orgId, id } = payload;
      await logoutOffline({
        userId: id,
        orgId,
      }).catch(noop);
    }
  };
};

export const useBeforeLogout = () => {
  const { t } = useTranslate();

  const { whiteListConfig: { SIMPLUS_CONV_STATUS } = {} } = useOrgConfigStateValue();

  const getPermission = useGetPermission();

  return useCallback(
    (onLogout: () => void) => {
      if (!SIMPLUS_CONV_STATUS || getPermission('管理员视角')) {
        return onLogout();
      }

      return Promise.all([
        advanceQueryConversationList({
          pageSize: 1,
          offset: '0',
          dir: 0,
          remind: true,
          statusFilters: ['UNPROCESSED', 'NOT_CLOSE'],
        }),
        advanceQueryConversationList({
          pageSize: 1,
          offset: '0',
          dir: 0,
          statusFilters: ['UNPROCESSED', 'NOT_CLOSE'],
        }),
      ])
        .then(([{ talkInfo: remindList }, { talkInfo: list }]) => {
          if (remindList.length > 0 || list.length > 0) {
            Modal.confirm({
              title: t('当前有会话未关闭，是否确认下线？'),
              onOk: onLogout,
            });
          } else {
            return onLogout();
          }
        })
        .catch(() => {
          return onLogout();
        });
    },
    [SIMPLUS_CONV_STATUS, getPermission, t],
  );
};

// 退出登陆
export const useLogout = () => {
  const logoutOfflineProtect = useLogoutOfflineProtect();
  const beforeLogout = useBeforeLogout();

  const onLogout = async (protect = false, logoutType?: LogoutType) => {
    await logoutOfflineProtect(protect);
    logout(logoutType);
  };

  return (protect = false, logoutType?: LogoutType) => {
    return beforeLogout(() => onLogout(protect, logoutType));
  };
};
